/**
 * Xdm Commission Rate service
 */
import { Injectable, Injector } from '@angular/core';
import { ColDef } from 'ag-grid-community';

import { BaseService } from '../base';
import { IEntityConfig, ENTITY_TYPES, BackendApiType } from '@shared/types';

const entityType: ENTITY_TYPES = ENTITY_TYPES.COMMISSION_RATE;
const config: IEntityConfig = {
  ENTITY_TYPE: entityType,
  isMasterListAvailable: true,
  buttons: null,
  apiEndpoint: entityType,
  uiRoute: entityType,
  backendApiType: BackendApiType.DM,
  customEntityRoute: {
    list: 'master',
  },
};

/**
 * Xdm Commission Rate service that extends BaseService to use
 * basic CRUD request operations
 */
@Injectable()
export class XdmCommissionRateService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;

  public quickFilterFields: string[] = ['name'];

  public listProjection: string[] = ['name'];

  public headerNames: ColDef[] = [
    {
      headerName: 'Name',
      field: 'name',
      filter: false,
    },
  ];

  public constructor(public injector: Injector) {
    super(injector);
    this.config = XdmCommissionRateService.config;
  }
}
